import { saveProfileLayout } from './saveProfileLayout';

export const layouts = {
  saveProfileLayout,
};
